import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '@reduxjs/toolkit/dist/createAsyncThunk';
import { LoginResponseDTO, LoginUserDTO } from 'types';
import LoginApi from 'api/LoginApi';
import { createNotification } from 'utils/utils';
import CompanyApi from 'api/CompanyApi';
import { setCompanies } from 'myredux/globalSlice';
import { setData } from 'myredux/loginSlice';


let login: ReturnType<typeof createAsyncThunk<LoginResponseDTO, LoginUserDTO, AsyncThunkConfig>>;

export function loginHandler() {
    login = createAsyncThunk(
        'auth/login',
        async ({ email, password }: LoginUserDTO, {dispatch, rejectWithValue}) => {
            const loginRes = (await LoginApi.login({email, password})).data;
            if (loginRes.code !== 'SUCCESS') {
                createNotification(loginRes.code, loginRes.message, 'Chyba uživatele');
                return rejectWithValue(loginRes.message);
            }

            dispatch(setData(loginRes.data));
            const companyRes = (await CompanyApi.getAllCompanies()).data;
            if (companyRes.code !== 'SUCCESS') {
                createNotification(loginRes.code, "Nepodařilo se načíst žádné společnosti pro které by bylo možné zobrazit data.", 'Chyba aplikace');
                return rejectWithValue(companyRes.message);
            }

            dispatch(setCompanies(companyRes.data)); 
            return loginRes.data;
        }
      );
}

export function processLogin() {
    return login;
}